import createReducer from "../BasicReducer";

export default createReducer('locale', '');